// ----------------------------------------------------------------------
// ShareBoost Translations - French
// ----------------------------------------------------------------------

export const shareboostFr = {
  shareboost_analytics: {
    view_analytics: 'Voir les Statistiques',
    hide_analytics: 'Masquer les Statistiques',
    error_loading: 'Erreur lors du chargement des statistiques ShareBoost',
    overview: 'Vue d\'ensemble',
    total_sharers: 'Total de Partageurs',
    total_shares: 'Total de Partages',
    total_clicks: 'Total de Clics',
    click_through_rate: 'Taux de Clic',
    total_conversions: 'Total de Conversions',
    conversion_rate: 'Taux de Conversion',
    total_cashback_allocated: 'Cashback Total Alloué',
    total_cashback_paid: 'Cashback Total Payé',
    budget_remaining: 'Budget Restant',
    transaction_status_distribution: 'Distribution des Statuts de Transaction',
    top_sharers: 'Meilleurs Partageurs',
    rank: 'Rang',
    sharer: 'Partageur',
    referrals: 'Parrainages',
    revenue_generated: 'Revenu Généré',
    cashback_earned: 'Cashback Gagné',
    no_sharers_yet: 'Aucun partageur pour le moment',
    recent_transactions: 'Transactions Récentes',
    recent_activity: 'Activité Récente',
    no_transactions_yet: 'Aucune transaction pour le moment',
    no_recent_clicks: 'Aucun clic récent',
    referred: 'Parrainé',
    visitor: 'Visiteur',
    potential: 'Potentiel',
    anonymous: 'Anonyme',
    status_active: 'actif',
    status_clicked: 'cliqué',
    status_pending_conversion: 'conversion en attente',
    status_completed: 'complété',
    status_failed: 'échoué',
  },
};

export default shareboostFr;
